import { Popup as ReactJSPopup } from "reactjs-popup";
import { PopupProps as IPopupProps } from "reactjs-popup/dist/types";

interface PopupProps {
  children:
    | React.ReactNode
    | ((close: () => void, isOpen: boolean) => React.ReactNode);
}

const Popup: React.FC<PopupProps & Omit<IPopupProps, "children">> = (props) => {
  return <ReactJSPopup {...(props as IPopupProps)} />;
};

export default Popup;
